// js
import React, { Component } from 'react';
import ReactDOMServer from 'react-dom/server';
import {IntlProvider} from 'react-intl';
import { Provider } from 'react-redux';


class StaticMarkup {
  constructor() {
    this.debug = false;
  }

  init(store) {
    this.store = store;
    if (this.debug) {
      this.store.subscribe(() => {
        const state = this.store.getState();
        console.debug('StaticMarkup: ', state);
      });
    }
  }

  renderToString(WrappedComponent, props, name) {
    const store = this.store;

    class StaticComponent extends Component {

      render() {
        return (
          <Provider store={store} >
            <IntlProvider locale='en'>
              <WrappedComponent {...props} pptxTarget={name} />
            </IntlProvider>
          </Provider>
        );
      }
    }

    const markup = ReactDOMServer.renderToStaticMarkup(<StaticComponent />);
    if (this.debug) console.debug('StaticMarkup: ', markup);
    return markup;
  }
}

export default new StaticMarkup();



// WEBPACK FOOTER //
// ./src/containers/pptx/StaticMarkup.js